<template>
  <div class="footer mt-2 mb-2">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <router-link to="/about" class="link col-6">About</router-link>
          <router-link to="/roadmap" class="link col-6">Roadmap</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer"
  }
</script>

<style scoped>
  .link {
    color: #F4833B;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue